import { render, staticRenderFns } from "./BehaviorAnalysis.vue?vue&type=template&id=cca52232&scoped=true&"
import script from "./BehaviorAnalysis.vue?vue&type=script&lang=js&"
export * from "./BehaviorAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./BehaviorAnalysis.vue?vue&type=style&index=0&id=cca52232&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca52232",
  null
  
)

export default component.exports